import { ref } from 'vue';
const key = 'ww-admin-customer';
function read() { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } }
export const selectedCustomer = ref(read());
export function customerForUser(userId, value = selectedCustomer.value) {
  return value && value.userId === userId && Number.isSafeInteger(value.customerId) && value.customerId > 0 ? value : null;
}
export function selectCustomer(userId, customer) {
  const value = {
    userId,
    customerId: Number(customer.customerId),
    customerName: customer.customerName,
    customerTypeCode: customer.customerTypeCode || null,
  };
  sessionStorage.setItem(key, JSON.stringify(value));
  selectedCustomer.value = value;
}
export function clearCustomer() { selectedCustomer.value = null; try { sessionStorage.removeItem(key); } catch {} }
